export enum QuoteSteps {
	Members = 1,
	Declaration = 2,
	QuoteList = 3,
	QuoteReview = 3.5,
	Documents = 4,
	DocumentsReview = 4.5,
	Payment = 5,
	PolicyIssuance = 6,
}

export enum Gender {
	Male = 1,
	Female = 2,
}

export enum KeyBenefits {
	Maternity = 3,
}

export enum PolicyType {
	OnlyMe = 1,
	MeAndFamily = 2,
	OnlyFamily = 3,
	DomesticWorker = 4,
}

export enum MaritalStatus {
	Single = 1,
	Married = 2,
}

export enum Relationship {
	Spouse = 1,
	Son = 2,
	Daughter = 3,
	Father = 4,
	Mother = 5,
	Self = 6,
	DomesticWorker = 7,
}

export enum ChannelType {
	Tamm = 1,
	Website = 2,
	MobileApp = 3,
	Admin = 4,
	Icp = 5,
}

export enum QuoteSort {
	PremiumLowHigh = '1',
	PremiumHighLow = '2',
	AnnualLowHigh = '3',
	AnnualHighLow = '4',
}

export enum BenefitCategory {
	InpatientTreatment = 1,
	OutpatientTreatment = 2,
	Maternity = 3,
	Dental = 4,
	Optical = 5,
	OtherSalientBenefits = 6,
	ClaimsSettlement = 7,
}

export enum FacilityTypes {
	Hospital = 1,
	Clinic = 2,
	Pharmacy = 3,
}

export enum HasEmiratesResponse {
	Yes = 1,
	No = 2,
}

export enum PaymentRadioOptions {
	CreditOrDebit = 1,
	ApplePay = 2,
}

export enum DocumentTypes {
	PassportScan = 2,
	VisaScan = 3,
	LabourContract = 4,
	InsuranceContinuityCertificateOrProofOfPayment = 8,
}

export enum UploadOperationTypes {
	Insertion = 1,
}

export enum GeneratedDocumentTypes {
	MedicalDeclaration = 1,
}

export enum SalaryBands {
	BelowOrUpTo4000 = 1,
	Above4000 = 2,
}

export enum PaymentProvider {
	CreditOrDebit = 1,
	AppleId = 6,
}

export enum QuoteStatus {
	Pending = 1,
	Failed = 2,
	Cancelled = 3,
	Issued = 4,
	Expired = 5,
}

export enum DataErrorAlertProps {
	DataError = 'DataError',
	WrongDataEntry = 'WrongDataEntry',
	InvalidMemberData = 'InvalidMemberData',
}

export enum UserAcknowledgementType {
	QuoteDeclarationAcknowledgement = 'QuoteDeclarationAcknowledgement',
	UserDocumentAcknowledgement = 'UserDocumentAcknowledgement',
	UserEmirateAcknowledgement = 'UserEmirateAcknowledgement',
	UserSalaryAcknowledgement = 'UserSalaryAcknowledgement',
}

export enum ErrorCode {
	InvalidNationalityForMe = 'InvalidNationalityForMe',
	InvalidNationalityForDependents = 'InvalidNationalityForDependents',
	MaxNumberOfMembers = 'MaxNumberOfMembers',
	InvalidDataError = 'InvalidDataError',
	DataEntryError = 'DataEntryError',
	TechnicalError = 'TechnicalError',
	ApiTimeOut = 'ApiTimeOut',
	InvalidMemberNationality = 'InvalidMemberNationality',
	WrongEidFormat = 'WrongEidFormat',
}

export enum PlanCategory {
	Basic = 1,
	Enhanced = 2,
	Both = 3,
}

export enum EmirateID {
	AbuDhabi = 1,
}

export enum PaymentVendorProvider {
	CheckoutUAE = 1,
	TelrUAE = 3,
}
